export class PershingModalConfig {
    /** Whether the dialog can be closed by clicking outside the dialog or ESC key */
    disableClose?: boolean = false;
    /** style class for the dialog */
    panelClass?: string | string[] = 'modal';
    /** unique id for the dialog */
    modalId: string;
    /** width */
    height?: string;
    /** maxWidth */
    maxHeight?: string;
    /** autoFocus */
    /** width */
    width?: string;
    /** maxWidth */
    maxWidth?: string;
    /** autoFocus */
    autoFocus?: boolean;
    /** data */
    data?: any;
}
